import { FC, memo } from 'react';
import NoItemsImage from 'assets/images/no-items.svg';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';

export type EmptyStateCardAction = {
  label: string;
  onClick: () => void;
  variant?: ButtonVariants;
  outlineStyle?: boolean;
  icon?: string;
  className?: string;
  testId?: string;
};

type EmptyStateCardProps = {
  mainMessage?: string;
  infoMessage?: string;
  imageIcon?: string;
  bordered?: boolean;
  centered?: boolean;
  action?: EmptyStateCardAction;
};

const EmptyStateCard: FC<EmptyStateCardProps> = ({
  mainMessage,
  infoMessage,
  imageIcon = NoItemsImage,
  bordered = true,
  centered = false,
  action,
}) => (
  <div className="nk-block">
    <div className={`card hover-shadow ${bordered ? 'card-bordered' : ''}`}>
      <div className="card-inner card-inner-lg">
        <div
          className={`nk-help ${
            centered ? 'd-flex justify-content-center' : ''
          }`}
        >
          <div className="nk-help-img">
            <img src={imageIcon} alt="imageIcon" />
          </div>

          <div
            className={`nk-help-text flex-grow-0${
              centered ? ' text-center' : ''
            }`}
          >
            {mainMessage && <h5>{mainMessage}</h5>}
            {infoMessage && <p className="text-soft">{infoMessage}</p>}
            {action && (
              <div className="mt-4">
                <Button
                  variant={action.variant ?? ButtonVariants.SECONDARY}
                  outlineStyle={action.outlineStyle ?? true}
                  onClick={action.onClick}
                  className={action.className}
                  data-testid={action.testId}
                  icon={action.icon}
                >
                  {action.label}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default memo(EmptyStateCard);
